import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import AddImageItem from 'components/AddImageItem';
import List from 'components/AssetList';
import Header from 'components/AssetList/Header';
import { useToggle } from 'components/AssetList/hooks';
import ImageListItem from 'components/ImageListItem';
import { EntityType } from 'const';
import { toggleUpdatedDocumentsDisplaying as toggleUpdatedDocumentsDisplayingAction } from 'containers/App/actions';
import * as AppModels from 'containers/App/models';
import { showUpdatedImages as showUpdatedImagesSelector } from 'containers/App/selectors';
import { ImageMap, ImagesMap } from 'models';
import { intlGet } from 'utils/intlGet';
import styles from './styles.module.scss';

type Props = {
  documents?: ImagesMap;
  isExpand?: boolean;
  showHeader: boolean;
  toggleExpand?(): void;
  updatedInPromoMats?: boolean;
  dataTestId?: string;
};

const ImageList: React.FunctionComponent<Props> = (props) => {
  const {
    documents,
    isExpand,
    showHeader,
    toggleExpand,
    updatedInPromoMats,
    dataTestId = 'imageList',
  } = props;
  const dispatch = useDispatch();
  const showUpdatedImages = useSelector(showUpdatedImagesSelector);
  const toggleUpdatedDocumentsDisplaying: AppModels.ActionCreator.ToggleUpdatedDocumentsDisplaying = (type, subtype) => {
    return dispatch(toggleUpdatedDocumentsDisplayingAction(type, subtype));
  };
  const {
    expanded,
    toggle,
  } = useToggle({
    toggleUpdatedDocumentsDisplaying,
    showUpdatedDocuments: showUpdatedImages,
    entityType: EntityType.IMAGE,
    toggle: toggleExpand,
    isExpand,
  });

  return (
    <div className={styles.ImageListContainer} data-title="images" data-testid={dataTestId}>
      {
        showHeader &&
        <Header
          title={intlGet('Assets', 'Images', { count: documents ? documents.size : 0 })}
          showUpdatesHint={updatedInPromoMats && showUpdatedImages}
          expanded={expanded}
          onClick={toggle}
          dataTestId={`${dataTestId}-header`}
        />
      }
      {
        (expanded || !showHeader) &&
        <List
          layout="grid"
          border={showHeader}
          elements={documents}
          subheader={showHeader && <AddImageItem dataTestId={`${dataTestId}-list-subheader`} />}
          renderElement={(document: ImageMap, index: number): React.ReactNode => (
            <ImageListItem
              key={document.get('id')}
              allowChange={showHeader}
              allowDelete={showHeader}
              component={document}
              dataTestId={`${dataTestId}-list-item${index}`}
            />
          )}
          dataTestId={`${dataTestId}-list`}
        />
      }
    </div>
  );
};

export default ImageList;
